"use strict";

exports.__esModule = true;
exports.auditLogsDefinition = void 0;
var _react = _interopRequireDefault(require("react"));
var _AuditLogDetails = require("../../../AuditLog/AuditLogDetails/AuditLogDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var auditLogsDefinition = exports.auditLogsDefinition = function auditLogsDefinition(translate) {
  return {
    columns: [{
      id: "timestamp",
      name: translate("DataTable.Column.Title.created", "Created At"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "userId",
      name: translate("DataTable.Column.Title.description", "User"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "resourceType",
      name: translate("DataTable.Column.Title.name", "Resource Type"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "resourceId",
      name: translate("DataTable.Column.Title.plant", "Resource Id"),
      type: "string",
      canFilter: false
    }, {
      id: "action",
      name: translate("DataTable.Column.Title.deviceName", "Action"),
      type: "deviceName",
      canSearch: true,
      canFilter: true
    }],
    SubComponent: function SubComponent(props) {
      var _props$rowData = props.rowData,
        row = _props$rowData.row,
        toggleRowSubComponent = _props$rowData.toggleRowSubComponent,
        nestingPath = _props$rowData.nestingPath,
        width = props.width,
        height = props.height,
        refreshData = props.refreshData;
      var auditLogId = row._original.id;
      return /*#__PURE__*/_react["default"].createElement(_AuditLogDetails.AuditLogDetails, {
        auditLogId: auditLogId,
        width: width,
        height: height,
        refreshData: refreshData,
        onClose: function onClose(e) {
          return toggleRowSubComponent({
            nestingPath: nestingPath
          }, e);
        }
      });
    },
    parseData: function parseData(responseData) {
      return {
        id: responseData._id,
        timestamp: responseData.timestamp,
        userId: responseData.userId,
        resourceType: responseData.resourceType,
        resourceId: responseData.resourceId,
        action: responseData.action,
        previousValue: responseData.previousValue,
        actualValue: responseData.value
      };
    },
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: false,
        defaultPageSize: "auto",
        columns: [{
          id: "timestamp",
          name: translate("DataTable.Column.Title.created", "Created At"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "userId",
          name: translate("DataTable.Column.Title.description", "User"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "resourceType",
          name: translate("DataTable.Column.Title.name", "Resource Type"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "resourceId",
          name: translate("DataTable.Column.Title.plant", "Resource Id"),
          type: "string",
          canFilter: false
        }, {
          id: "action",
          name: translate("DataTable.Column.Title.deviceName", "Action"),
          type: "deviceName",
          canSearch: true,
          canFilter: true
        }]
      };
    }
  };
};